import {
  GuidedTourType,
  GuidedTourStep,
} from '@baserow/modules/core/guidedTourTypes'

class FreeTrialStartedGuidedTourStep extends GuidedTourStep {
  get title() {
    return this.app.i18n.t('freeTrialStartedGuidedTourStep.title')
  }

  get content() {
    return this.app.i18n.t('freeTrialStartedGuidedTourStep.content')
  }

  get selectors() {
    return []
  }

  get position() {
    return 'center saas-free-trial-guided-tour-step'
  }

  get skipIfNotFirst() {
    return true
  }
}

export class FreeTrialGuidedTourType extends GuidedTourType {
  static getType() {
    return 'free_trial'
  }

  /**
   * No need to save the state because we might want to show this tour again to the
   * user if another workspace started the free trial.
   */
  get saveCompleted() {
    return false
  }

  get steps() {
    return [new FreeTrialStartedGuidedTourStep(this.app)]
  }

  get order() {
    return 10000
  }

  completed() {
    this.app.store.dispatch('saasApp/setShowFreeTrialStep', false)
  }

  isActive() {
    return this.app.store.getters['saasApp/getShowFreeTrialStep']
  }
}
